import { Tooltip } from "antd";
import AvatarImage from "_assets/images/profile/avatar.avif";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import {
  StyledAppAvatar,
  StyledAppAvatarContainer,
  StyledAppAvatarSVGBackground,
  StyledAppAvatarSVGWrapper,
} from "./index.styled";
import { useCommon, useKYCStatus } from "_hooks";
import { PROFILE_ROUTE } from "_constants";

const AppAvatar = () => {
  const { isVerified } = useKYCStatus();
  const { onRedirect } = useCommon();

  return (
    <Tooltip title={isVerified ? "Verified" : "Unverified"}>
      <StyledAppAvatarContainer onClick={onRedirect(PROFILE_ROUTE)}>
        <StyledAppAvatar size={40} shape="circle" src={AvatarImage} />
        {isVerified && (
          <StyledAppAvatarSVGWrapper>
            <StyledAppAvatarSVGBackground />
            <RiVerifiedBadgeFill size={14} color="blue" />
          </StyledAppAvatarSVGWrapper>
        )}
      </StyledAppAvatarContainer>
    </Tooltip>
  );
};

export default AppAvatar;
